import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';
import * as NotFoundImage from '../../assets/images/not_found.png';
import { mergeStyles } from '@cian/utils';

export interface IValuationNotFound {
  isDesktop: boolean;
}
export const ValuationNotFound: React.FC<IValuationNotFound> = ({ isDesktop }) => {
  return (
    <div {...mergeStyles(styles['container'], isDesktop ? styles['container_desktop'] : styles['container_mobile'])}>
      <img className={styles['image']} src={NotFoundImage} alt="" />
      <InlineText2>У нас пока нет оценки по этому адресу</InlineText2>
    </div>
  );
};

ValuationNotFound.displayName = 'ValuationNotFound';
